import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["contributor", "month", "preview"]
  static values = {
    previewUrl: String,
    generateUrl: String
  }

  connect() {
    if (this.hasPreviewTarget) this.autoLoadFromParams()
  }

  loadPreview() {
    if (!this.hasPreviewTarget) return

    const contributorId = this.contributorTarget.value
    const releaseMonth = this.monthTarget.value

    if (!contributorId || !releaseMonth) return

    this.previewTarget.innerHTML = this.loadingMarkup()

    const url = `${this.previewUrlValue}?contributor_id=${contributorId}&release_month=${releaseMonth}-01`

    fetch(url, {
      headers: {
        "Accept": "text/html",
        "X-Requested-With": "XMLHttpRequest"
      }
    })
      .then(response => response.text())
      .then(html => { this.previewTarget.innerHTML = html })
      .catch(() => {
        this.previewTarget.innerHTML = this.errorMarkup()
      })
  }

  generate(event) {
    event.preventDefault()

    const contributorId = this.contributorTarget.value
    const releaseMonth = this.monthTarget.value

    if (!contributorId || !releaseMonth) {
      alert("Please select both a contributor and a release month.")
      return
    }

    window.location.href = `${this.generateUrlValue}?contributor_id=${contributorId}&release_month=${releaseMonth}`
  }

  // Private

  autoLoadFromParams() {
    const params = new URLSearchParams(window.location.search)
    const contributorId = params.get("contributor_id")
    const releaseMonth = params.get("release_month")

    if (contributorId && releaseMonth) {
      this.contributorTarget.value = contributorId
      this.monthTarget.value = releaseMonth
      this.loadPreview()
    }
  }

  loadingMarkup() {
    return `
      <div class="text-center py-5">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <p class="text-muted mt-2">Loading eligible ideas...</p>
      </div>
    `
  }

  errorMarkup() {
    return `
      <div class="text-center py-5" style="background-color: #f9fafb; border-radius: 8px;">
        <p class="text-danger mb-0">Failed to load preview. Please try again.</p>
      </div>
    `
  }
}
